export default function JobDetail ( { jobInfo }) {
    return (
        <div className="flex-col md:ml-4">
            <div className="big-p">{jobInfo.position} at {jobInfo.company}</div>
            <div className="small-p">{jobInfo.dates}</div>
            <ul className="list-image-chevron body-p mt-2">
                {jobInfo.details.map((detail, idx) => <li className="mt-2" key={idx}>{detail}</li>)}
            </ul>
        </div> 
    )
}